import React, { useRef, useEffect, useState, useContext } from "react";
import { useSelector } from "react-redux";
import { jsonEditorContext } from "../../../Context/jsonEditorContext";
import { useTranslation } from "react-i18next";
import ChangeResumeOrder from "../../../hooks/editor/changeResumeOrder";
import ContentEditable from "../../../Components/ContentEditable/ContentEditable";
import Quilleditor from "../../../Components/Quilleditor/Quileditor_New";
import VisualSuggest from "../../../Components/SuggestionVisual/SuggestionVisual";
import { ResumePopupContext } from "../../../Context/resumePopupContext";
import SectionHeader from "../SectionHeader/sectionHeader";
import SectionItemWrapper from "../SectionItemWrapper/SectionItemWrapper";
const { forwardRef, useImperativeHandle } = React;

function Summary(props, ref) {
  const {
    resumeFields,
    sectionId,
    resumeTitleHandler,
    handleEditorChange,
    resumeUpdate,
    styles,
    settings,
    contentAdder,
    PageMargin,
    SectionMargin,
  } = props;
  const { selectedFont, primaryColor, secondaryColor, titleFont, bodyFont } =
    styles;
  const analyzerData = useSelector((state) => state.analyzeResume.data);

  const [showQuillToolbar, setShowQuillToolbar] = useState(true);
  const [showSuggest, setShowSuggest] = useState(false);

  const changesetShowQuillToolbar = (status) => {
    props.changeSummaryQuillEditor(status);
  };

  const { setSuggestionIndex } = useContext(ResumePopupContext);
  const [t, i18n] = useTranslation("common");

  const handleSuggestion = (job, index) => {
    setShowSuggest(true);
    setSuggestionIndex(index);
  };
  const hideSuggest = () => {
    setShowSuggest(false);
  };
  useEffect(() => {
    if (props.newSectionFocus != props.sectionId) {
      setShowSuggest(false);
    }
  }, [props.newSectionFocus]);

  const innerSectionClick = (e, index) => {
    props.changeFocusStyle(props.sectionId, index.toString(), "section");
  };

  return (
    <>
      {resumeFields && resumeFields.show && (
        <>
          <>
            <SectionHeader
              styles={styles}
              settings={settings}
              resumeFields={resumeFields}
              sectionId={sectionId}
              resumeTitleHandler={resumeTitleHandler}
              resumeUpdate={resumeUpdate}
              PageMargin={PageMargin}
              SectionMargin={SectionMargin}
            />
            <div className="section-item-wrapper summary-item-wrapper">
              {resumeFields &&
                resumeFields.data &&
                resumeFields.data.map((response, index) => (
                  <SectionItemWrapper
                    sectionId={sectionId}
                    styles={styles}
                    style={{ position: "relative" }}
                    // layout={layout}
                    index={index}
                    newSectionFocus={props.newSectionFocus}
                    currentStateFocus={props.currentStateFocus}
                    newItemFocus={props.newItemFocus}
                    SectionMargin={SectionMargin}
                    onMouseDown={(e) => e.stopPropagation()}
                    onClick={(e) => {
                      e.stopPropagation();
                      innerSectionClick(e, index);
                    }}
                  >
                    {/* <div
                      className="summary-item resume-item "
                      id={`summary-${index}`}
                    > */}
                    {showQuillToolbar &&
                      props.newSectionFocus == props.sectionId && (
                        <p
                          className="suggestion-text"
                          onClick={() =>
                            handleSuggestion(response.position, index)
                          }
                        >
                          Show Suggestions
                          <i
                            class="fa fa-plus-circle basic-suggestion-add-icon"
                            aria-hidden="true"
                          ></i>
                        </p>
                      )}
                    {showSuggest &&
                      showSuggest &&
                      props.newSectionFocus == props.sectionId &&
                      props.newItemFocus == index.toString() && (
                        <VisualSuggest
                          job={props.profileJob}
                          sectionId={props.sectionId}
                          index={index}
                          hideSuggest={hideSuggest}
                          showSuggest={showSuggest}
                          contentAdder={contentAdder}
                        />
                      )}
                    <Quilleditor
                      type="visual"
                      showQuillToolbar={showQuillToolbar}
                      changesetShowQuillToolbar={changesetShowQuillToolbar}
                      theme="snow"
                      className={``}
                      inivalue={
                        response?.description
                          ? response?.description?.replace(/\n|\r/g, "")
                          : ""
                      }
                      current={index}
                      setvalue={handleEditorChange}
                      onBlur={resumeUpdate}
                      styles={styles}
                      id={props.sectionId}
                      sectionId={props.sectionId}
                      placeholder="Whats the one thing that you want someone to remember to after reading your resume?"
                    />
                    {/* </div> */}
                  </SectionItemWrapper>
                ))}
            </div>
          </>
        </>
      )}
    </>
  );
}

export default forwardRef(Summary);
